import styled from "@emotion/styled"
import { DonationMessages } from "app/[locale]/(layout)/donation-application-form/page"
import { NewText } from "ui"
import FileSelectCard from "./FileSelectCard"

const StyledContainer = styled.div`
  ${(props) => props.theme.breakpoints.up("md")} {
  }
`

const StyledGridLayout = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  ${(props) => props.theme.breakpoints.up("md")} {
    grid-template-columns: 1fr 1fr 1fr;
  }
`

const StyledButton = styled.button`
  background-color: white;
  display: flex;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  border-radius: 200px;
  border: 2px solid #000;
  margin-left: auto;
  min-width: 121px;
  margin-top: 24px;
  &:focus-visible {
    outline: 2px solid currentColor;
    outline-offset: 2px;
  }
  &:disabled {
    border: 2px solid #6f6f6f;
    color: #6f6f6f;
  }
`
const StyledDivider = styled.div`
  height: 1px;
  width: 100%;
  background: #6f6f6f;
  margin: 32px 0 16px 0;
`

type Props = {
  isStepCValid: any
  formFiles: any
  setFormFiles: any
  control: any
  errors: any
  watch: any
  setAtiveAcordion: any
  isStepAValid: any
  isStepBValid: any
  handleSubmit: any
  errorOnFiles: boolean
  messages: DonationMessages
}

const StepC: React.FC<Props> = ({ formFiles, setFormFiles, errorOnFiles, messages }) => {
  const isValid = (target: any) => {
    if (formFiles[target] === null) {
      return false
    }
    if (formFiles[target]?.type === "application/pdf") {
      return true
    }
  }

  return (
    <StyledContainer>
      <div role="group" aria-labelledby="documents-list-heading">
        <NewText
          id="documents-list-heading"
          desktopFontSize={14}
          desktopFontWeight="400"
          desktopLineHeight="20px"
          mobileFontSize={12}
          mobileFontWeight="400"
          mobileLineHeight={"17px"}
          component="p"
          color={"black"}
          style={{ maxWidth: "560px", marginTop: "8px", marginBottom: "16px" }}
        >
          {messages.listOfDocu}
        </NewText>
        <StyledGridLayout>
          <FileSelectCard
            upload={messages.upload}
            error={errorOnFiles}
            target="PartCCeoSignedRequestLetterWithLawyerApproved"
            title={messages.aLetterOfR}
            setFormFiles={setFormFiles}
            isValid={isValid}
            errorMessage={messages.fileRequired}
          />
          <FileSelectCard
            upload={messages.upload}
            error={errorOnFiles}
            target="PartCTaxExemption"
            title={messages.updatedCon}
            setFormFiles={setFormFiles}
            isValid={isValid}
            errorMessage={messages.fileRequired}
          />
          <FileSelectCard
            upload={messages.upload}
            error={errorOnFiles}
            target="PartCIRSApprovalBookKeeping"
            title={messages.updatedAnd}
            setFormFiles={setFormFiles}
            isValid={isValid}
            errorMessage={messages.fileRequired}
          />
          <FileSelectCard
            upload={messages.upload}
            error={errorOnFiles}
            target="PartCNonProfitsRegistrationManagementApproval"
            title={messages.validPrope}
            setFormFiles={setFormFiles}
            isValid={isValid}
            errorMessage={messages.fileRequired}
          />
          <FileSelectCard
            upload={messages.upload}
            error={errorOnFiles}
            target="PartCIncomeTaxSection46"
            title={messages.updatedCo1}
            setFormFiles={setFormFiles}
            isValid={isValid}
            errorMessage={messages.fileRequired}
          />
          <FileSelectCard
            upload={messages.upload}
            error={errorOnFiles}
            target="PartCAssociationTerms"
            title={messages.aCopyOfThe}
            setFormFiles={setFormFiles}
            isValid={isValid}
            errorMessage={messages.fileRequired}
          />
        </StyledGridLayout>
      </div>
      <StyledButton type="submit">
        <NewText
          desktopFontSize={14}
          desktopFontWeight="600"
          desktopLineHeight="20px"
          mobileFontSize={12}
          mobileFontWeight="600"
          mobileLineHeight={"17px"}
          component="p"
          color={"black"}
          marginRight="4px"
          maxWidth={"80%"}
        >
          {messages.send}
        </NewText>
      </StyledButton>
      <StyledDivider />
      <NewText
        desktopFontSize={14}
        desktopFontWeight="400"
        desktopLineHeight="20px"
        mobileFontSize={12}
        mobileFontWeight="400"
        mobileLineHeight={"17px"}
        component="p"
        color={"black"}
        style={{ maxWidth: "600px", marginBottom: "16px" }}
      >
        {messages.itShouldBe}
      </NewText>
    </StyledContainer>
  )
}

export default StepC
